import { Text } from "@medusajs/ui"

import LocalizedClientLink from "@modules/common/components/localized-client-link"
import { ProductRating } from "@modules/products/templates/product-rating"

import Thumbnail, { ThumbnailSize } from "../thumbnail"
import PercentageDiscountPreview from "./components/PercentageDiscountPreview"
import PricePreview, { PricePreviewType } from "./components/PricePreview"

type ProductPreviewTemplateProps = {
  title: string
  thumbnail: string
  thumbnailSize?: ThumbnailSize
  href?: string
  percentageDiscount?: number
  isFeatured?: boolean
  hasFreeShipping?: boolean
  originalPrice?: string
  calculatedPrice?: string
  pagosPrice?: number
  onClick?: () => void
  rating: {
    count_responses: number
    average_rating: number
  } | null
}

export default function ProductPreviewTemplate({
  title,
  href = "/",
  thumbnail,
  thumbnailSize = "full",
  isFeatured,
  percentageDiscount,
  hasFreeShipping,
  originalPrice,
  calculatedPrice,
  pagosPrice,
  rating,
  onClick,
}: ProductPreviewTemplateProps) {
  return (
    <LocalizedClientLink key={`${title}_${href}`} href={href} onClick={onClick} className="group">
      <div>
        <div className="relative mb-2">
          {!!percentageDiscount && <PercentageDiscountPreview percentageDiscount={percentageDiscount} />}
          <div className="relative overflow-hidden rounded-lg">
            <Thumbnail thumbnail={thumbnail} size={thumbnailSize} isFeatured={isFeatured} />
            <div className="pointer-events-none absolute inset-0 bg-gray-500 opacity-0 transition-opacity duration-150 group-active:opacity-30"></div>
          </div>
        </div>
        {originalPrice && (
          <PricePreview
            type={
              originalPrice && calculatedPrice && originalPrice !== calculatedPrice
                ? PricePreviewType.DISCOUNT_STRIKE_THROUGH
                : PricePreviewType.DEFAULT
            }
            originalPrice={originalPrice}
            calculatedPrice={calculatedPrice}
          />
        )}
        {pagosPrice && <p className="tracking-0 mb-2 text-[14px] font-medium text-nelo-blue">4 pagos de ${pagosPrice.toFixed(2)}</p>}
        <div className="mb-1 flex flex-wrap gap-2">
          <div className="z-1 flex w-fit items-center gap-x-1 rounded-md bg-[#E1F4FF] px-1 py-0.5 text-white">
            <span className="text-xs font-medium text-nelo-blue">Sin intereses</span>
          </div>
          {hasFreeShipping && (
            <div className="z-1 flex w-fit items-center gap-x-1 rounded-md bg-[#E5FAE9] px-1 py-0.5 text-white">
              <span className="text-xs font-medium text-[#256A34]">Envío gratis</span>
            </div>
          )}
        </div>

        <div className="txt-compact-medium">
          <Text className="line-clamp-1 font-inter leading-tight text-nelo-dark-gray">{title}</Text>
          {rating && rating.average_rating > 2 && (
            <div className="text-[10px] lg:text-sm">
              <ProductRating rating={rating.average_rating} count_responses={rating.count_responses} />
            </div>
          )}
        </div>
      </div>
    </LocalizedClientLink>
  )
}
